import React, { useState } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { withStyles, Button, Dialog } from "@material-ui/core";
import * as actions from "../../sc-core/Auth/store/authActions";
import ForgotPasswordForm from './ForgotPasswordForm';

const styles = theme => ({
    btn: {
        textAlign: 'right', marginLeft: '50%', marginBottom: '0.3rem'
    },
    formControl: {
        marginTop: theme.spacing(5),
        width: "100%",
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh'
    },
    submit: {
        width: "100%",
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

let initialValuesPassword = {
    Email: ''
};

const ForgotPassword = props => {
    const { classes, onForgotPassword, translations } = props;

    const [open, setOpen] = useState(false);

    const handleOpenToggle = () => {
        setOpen(!open);
    };

    let formSettingsPassword = {
        Validation: {
            Email: Yup.string().email().required("Required"),
        },
        ButtonSubmit: {
            Title: translations["submit"] || "Submit",
            Color: "primary"
        },
    };

    const handleSubmitPasswordChange = async (data) => {
        let res = await onForgotPassword(data);
        res.status === 200 && handleOpenToggle();
    };

    return (
        <>
            <Button className={classes.btn} color="primary" onClick={handleOpenToggle} onClose={handleOpenToggle}>{(translations['forgot_password'] || 'Forgot password').toLowerCase()}?</Button>
            <Dialog open={open} onClose={handleOpenToggle} classes={{ paper: classes.dialogPaper }}>
                <ForgotPasswordForm
                    translations={translations}
                    handleSubmit={handleSubmitPasswordChange}
                    initialValues={initialValuesPassword}
                    formSettings={formSettingsPassword} />
            </Dialog>
        </>
    );
}

const mapStateToProps = state => {
    return { translations: state?.translate?.translations?.activeTranslations || {} }
};

const mapDispatchToProps = dispatch => {
    return { onForgotPassword: params => dispatch(actions.forgotPassword(params)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ForgotPassword));
